import { ProductItemPublic, ProductItemPrivate, ProductType, ProductCategory } from './types'

export const emptyProductItemPublic: ProductItemPublic = {
  uuid: '',
  slug: '',
  name: '',
  price: 0,
  description: '',
  reference: '',
  type: '',
  category: '',
  attributes: [],
  images: [],
  manufacturer: '',
  thumbnail: '',              // eslint-disable-line
  discount_pct: 0,           // eslint-disable-line
  views: 0,
  stock: 0
}

export const emptyProductItemPrivate: ProductItemPrivate = {
  uuid: '',
  slug: '',
  name: '',
  price: 0,
  description: '',
  reference: '',
  type: '',
  category: '',
  attributes: [],
  images: [],
  manufacturer: '',
  thumbnail: '',              // eslint-disable-line
  discount_pct: 0,           // eslint-disable-line
  views: 0,                 // eslint-disable-line
  stock: 0,
  registered_at: '',
  visible: false
}

export const emptyProductTypeInstance: ProductType = {
  uuid: '',
  name: '',
  slug: '',
  categories: []
}

export const emptyProductCategoryInstance: ProductCategory = {
  uuid: '',
  name: '',
  slug: ''
}
